import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const ImageCardCarouselContainer = styled.div`
  .card-container,
  .placeholder-card {
    width: ${cssVar('width-xs')};
  }

  .image-card-item {
    max-width: ${cssVar('width-xs')};
    height: 100%;

    > *,
    .image-card {
      height: 100%;
    }
  }
`;
